import { IAuthenticationProvider, AuthEnvironment, UIAuthProvider, CheckAndThrowCannotGetAuthContextError, GetAccessTokenOptions } from "../../interfaces/IAuthenticationProvider";
import { AuthSharedComponent } from "./AuthSharedComponent";
import { AuthErrors, AuthError } from './AuthErrors';
import { IS_DEV_BUILD } from '../../../AppConstants';
import { ErrorStringFromException } from "../../../utils/utils";

/*
    Prod stands for "Production environment".
    It also includes the dogfood environment (i.e string "-df" may be appended somewhere on their URL)

    For ex: www.office.com, microsoft.sharepoint.com, microsoft.sharepoint-df.com etc
*/
export class ProdAuthenticationProvider implements IAuthenticationProvider {
    private authSharedComponent: AuthSharedComponent = new AuthSharedComponent();

    Authenticate(): void {
        // Workaround for ICE bug https://office.visualstudio.com/OC/_workitems/edit/4132146
        if (IS_DEV_BUILD) {
            OfficeFirstPartyAuth.debugging = true;
            OfficeFirstPartyAuth.authorityOverride = "https://login.microsoftonline.com/";
        }

        try {
            this.authSharedComponent.Authenticate();
        } catch (error) {
            throw new AuthError(AuthErrors.UnableToAuthenticate, ErrorStringFromException(error));
        }
    }

    async GetAccessToken(options: GetAccessTokenOptions): Promise<string> {
        try {
            return await this.authSharedComponent.GetAccessToken(options);
        } catch (error) {
            CheckAndThrowCannotGetAuthContextError(error);
            throw new AuthError(AuthErrors.UnableToFetchToken, ErrorStringFromException(error));
        }
    }

    GetAuthEnvironment(): AuthEnvironment {
        return AuthEnvironment.Prod;
    }

    SetUIAuthProvider(uiAuthProvider: UIAuthProvider): void {
        this.authSharedComponent.SetUIAuthProvider(uiAuthProvider);
    }
}